import { ICard } from '../../card/types';
import { ICardsComparator } from './types';
import { compareNumbers } from './compareNumbers';

const getCardValue = (
    card: ICard,
): number => card.lastActivityDateStamp;

export const lastActivity: ICardsComparator = {
    getCardValue,
    sort: compareNumbers
}
